// extracted by mini-css-extract-plugin
export default {"toolbarPosition":"pricingExtremeAdpriceSchemaTypeGrid_toolbarPosition__I69qH"};